import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { TeacherPayrollRecord } from './useTeacherPayroll';
import { toast } from 'sonner';

interface GenerateSlipResult {
  success: boolean;
  data?: {
    slipUrl?: string;
    tavi50Url?: string;
  };
  error?: string;
}

export function useGenerateTeacherSlip() {
  const [isGenerating, setIsGenerating] = useState(false);

  const generateSlip = async (
    salary: TeacherPayrollRecord,
    paidDate: string
  ): Promise<GenerateSlipResult> => {
    setIsGenerating(true);
    try {
      const { data, error } = await supabase.functions.invoke('generate-slip', {
        body: {
          data: {
            id: salary.id,
            type: "FS_TEACHER",
            code: salary.รหัส,
            month: salary.month,
            employeeName: salary['ชื่อจริง-นามสกุล'],
            baseSalary: salary.เงินเดือน,
            totalSalary: salary.รวมเงินเดือน,
            year: (salary.year + 543).toString(),
            payDate: paidDate,
            socialSecurity: "",
            compensationType: "COMMISSION",
            compensationAmount: salary.ค่าคอมมิชชั่น || 0,
            deductionType: "PND3",
            deductionAmount: salary['ภงด.3'] || 0,
            lwopDeductionAmount: 0,
            totalDeduction: salary['ภงด.3'] || 0,
            netSalary: salary.เงินสุทธิรวมประกัน,
            loss: 0,
            taviData: {
              citizenId: salary.รหัสบัตรประชาชน,
              taxAddress: salary.ที่อยู่ผู้เสียภาษี,
            }
          }
        }
      });

      if (error) {
        console.error('Generate slip error:', error);
        toast.error('ไม่สามารถสร้างสลิปได้: ' + error.message);
        return { success: false, error: error.message };
      }

      toast.success('สร้างสลิปเรียบร้อยแล้ว');
      return { success: true, data: data?.data };
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Unknown error';
      console.error('Generate slip exception:', err);
      toast.error('เกิดข้อผิดพลาด: ' + message);
      return { success: false, error: message };
    } finally {
      setIsGenerating(false);
    }
  };

  return { generateSlip, isGenerating };
}
